import React, { useEffect } from "react";
import CardInfo from "../../sections/car-booking-card-info";
import AccordionWrapper from "../../elements/accordion-wrapper";
import BodyText from "../../elements/body-text";
import "./style.scss";
import TrustSeals from "../trust-seals";
import { useDispatch, useSelector } from "react-redux";
import { setPdpCheckoutProgressAction } from "../../redux/actions";
import { pdpCheckoutProgressSelector } from "../../selectors/pdp";
import useCartData from "../../hooks/useCartData";
import useDeliveryMethods from "../../hooks/useDeliveryMethods";

const CarBookingDeliveryCheckout = ({ fields, bookingDetails, trustSeals }) => {
  /*Redux Start*/
  const dispatch = useDispatch();
  const setCheckoutProgress = payload => dispatch(setPdpCheckoutProgressAction(payload));
  const pdpCheckoutProgress = useSelector(pdpCheckoutProgressSelector);
  /*Redux End*/
  const { headingType, headingBody, isExpanded, cardInfo } = fields;
  const { cartSpuIds } = useCartData();
  // const { progressBar } = useCarBookingProgressBar({ fields });
  const { deliveryMethods } = useDeliveryMethods(cartSpuIds);
  useEffect(() => {
    setCheckoutProgress({
      steps: [
        {
          label: "",
          done: true,
          active: false,
          route: "#",
          disabled: true
        },
        {
          label: "",
          done: true,
          active: false,
          route: "#",
          disabled: true
        },
        {
          label: "",
          done: true,
          active: true,
          route: "#",
          disabled: false
        }
      ]
    });
  }, []);
  const accordionWrapperProps = {
    heading: {
      type: headingType,
      html: headingBody
    },
    open: isExpanded.value
  };
  const cardInfoProps = {
    fields: cardInfo.fields,
    onSubmit() {}
  };

  return (
    <section className="car-delivery-checkout">
      <AccordionWrapper {...accordionWrapperProps}>
        <div className="booking-content">
          {bookingDetails.body && <BodyText html={bookingDetails.body.html} className="booking-description" />}
          <div className="booking-details">
            {bookingDetails.deliveryDetails.items.map(item => {
              const { label, value } = item;
              return (
                <div className="booking-row" key={label + value}>
                  <div className="label">{label}</div>
                  <div className="value">{value}</div>
                </div>
              );
            })}
          </div>
          <div className="location">
            <div className="location-heading">{bookingDetails.location.heading.label}</div>
            <div className="location-street">{bookingDetails.location.street.label}</div>
            <div className="location-city">{bookingDetails.location.city.label}</div>
          </div>
        </div>
        {}
      </AccordionWrapper>
      <CardInfo className="card-info" {...cardInfoProps} />
      <TrustSeals className="trust-seals" images={trustSeals} />
    </section>
  );
};

export default CarBookingDeliveryCheckout;
